import styled from 'styled-components'
import { Root } from '@radix-ui/react-checkbox'
import { CheckIcon } from '@velasca/icons/check'

export const StyledRoot = styled(Root)`
  position: relative;
  padding: 0.6rem;
  background: none;
  border: 2px solid ${({ theme }) => theme.colors.primary};
  border-radius: 0.1rem;

  span {
    line-height: 0;
    font-size: 0;
  }

  &[data-state='checked'] {
    background-color: ${({ theme }) => theme.colors.primary};
  }
`

export const StyledCheckIcon = styled(CheckIcon)`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
`
